<template lang="html">
    <p class="section-subheading"><slot></slot></p>
</template>

<script>
export default {
    name: "SectionSubheading",
};
</script>

<style scoped>
.section-subheading {
    color: #202020;
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.8;
    text-wrap: balance;
}
</style>
